import React from 'react';
import { Box, Typography } from '@mui/material';
import GridLayout from '../components/layout/GridLayout';
import Menu from '../components/layout/Menu';
import Card from '../components/ui/Card';

// This defines the props so TypeScript doesn't throw the TS2304 error
interface ContactPageProps {
  isMenuOpen?: boolean;
}

export default function ContactPage({ isMenuOpen = false }: ContactPageProps) {
  return (
    <GridLayout
      isMenuOpen={isMenuOpen}
      left={<Menu />}
      main={
        <Card>
          {/* Unified Brand Title */}
          <Typography variant="h4" sx={{ color: '#34de9aab', fontWeight: 'bold', mb: 3 }}>
            Contact
          </Typography>
          
          <Box sx={{ mt: 4 }}>
            <Typography sx={{ mb: 1 }}>Email: info@heremaimai.com</Typography>
            <Typography sx={{ mb: 1 }}>line:  </Typography>
            <Typography sx={{ mb: 1 }}>Address: 35, Soi 11, Suthep, Chiang Mai, Thailand</Typography>
            
            <Box 
              component="img" 
              src="/images/mascot.png" 
              alt="Mascot" 
              sx={{ width: 120, mt: 4, display: 'block' }} 
            />
          </Box>
        </Card>
      }
      right={<Box />}
    />
  );
}